export default __webpack_public_path__ + "static/media/50 inex_04.c1fa0e0c.png";